<style scoped lang="less" rel="stylesheet/less">
.coinWebView_box,
iframe {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 27;
  background: #0089ce;
  overflow: hidden;
}
.bottom_bg {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 29;
  pointer-events: none;
  img {
    width: 100%;
    height: auto;
  }
}
</style>
<template>
  <div class="coinWebView_box">
    <Back @goBack="goBack" />
    <iframe :src="iframeUrl" frameborder="0"></iframe>
    <div class="bottom_bg">
      <img src="../../../assets/img/class/bottom_bg.png" alt />
    </div>
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
import common from "common";
export default {
  name: "coinexplain",
  data() {
    return {
      iframeUrl: common.API['700041']+'coinexplain'
    };
  },
  components: {
    Back
  },
  created() {
    // this.iframeUrl = `http://127.0.0.1:8000/coinexplain?entrance=speed`;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/class/coinexplain.vue